export const visit_places = [
  {
    name: "Dam Square",
    image:
      "https://tse1.mm.bing.net/th/id/OIP.F79g5xouWSwfqhinPOTVhQHaE7?pid=Api&P=0&h=180",
    km: "0.8",
  },
  {
    name: "Anne Frank House",
    image:
      "https://a.travel-assets.com/findyours-php/viewfinder/images/res70/550000/550930-anne-frank-house.webp",
    km: "0.5",
  },
  {
    name: "The Royal Palace of Amsterdam",
    image:
      "https://wallpapers.com/images/hd/amsterdam-royal-palace-photography-e10zrb1pad6c7ld5.webp",
    km: "0.9",
  },
  {
    name: "Albert Cuyp Market",
    image:
    " https://c8.alamy.com/comp/BFA6WT/amsterdam-albert-cuypstraat-cuyp-market-netherlands-BFA6WT.webp",
    km: "2.1",
  },
  {
    name: "NEMO Science Museum",
    image:
      "https://media.cntraveler.com/photos/540a297981424d9d655be1e5/master/pass/nemo-science-museum-amsterdam.webp",
    km: "1.8",
  },
];